import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Controller, useFormContext } from 'react-hook-form';

import { DatePicker } from '@mui/x-date-pickers';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function HomeworkDueDateField() {
  const { control } = useFormContext();

  return (
    <Controller
      name="dueDate"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          label="Due Date"
          value={dayjs
            .tz(field.value, Intl.DateTimeFormat().resolvedOptions().timeZone)
            .toDate()}
          onChange={(newValue) => {
            field.onChange(newValue);
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error?.message
            }
          }}
        />
      )}
    />
  );
}
